import axios from 'axios';

// Use relative path '/api' to ensure requests go to the same origin (preserving cookies)
// This works in Prod because Nginx/Ingress routes /api to backend.
// This works in Dev because package.json "proxy" forwards /api to localhost:8001.
const baseURL = '/api';

export const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true // Important for cookies
});
